module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "trial-courses"
  }, [_c('div', {
    staticClass: "panel"
  }, [(!_vm.selectedCourse) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('ul', {
    staticClass: "course-list"
  }, _vm._l((_vm.courses), function(course) {
    return _c('li', {
      key: course.id
    }, [_c('span', [_vm._v(_vm._s(course.name))]), _vm._v(" "), _c('div', {
      staticClass: "buttons"
    }, [_c('button', {
      staticClass: "btn btn-default btn-sm",
      on: {
        "click": function($event) {
          _vm.editCourse(course)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          _vm.openCourse(course)
        }
      }
    }, [_vm._v("Open")])])])
  })), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm",
    on: {
      "click": function($event) {
        _vm.showCreateModal = true
      }
    }
  }, [_vm._v("Create New Trial Course")])]) : (!_vm.selectedLesson) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('button', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": function($event) {
        _vm.selectedCourse = null
      }
    }
  }, [_vm._v("← Back")]), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.selectedCourse.name))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm",
    on: {
      "click": function($event) {
        _vm.scheduleCourse()
      }
    }
  }, [_vm._v("Schedule New Run")])]), _vm._v(" "), _c('ul', {
    staticClass: "lesson-list"
  }, _vm._l((_vm.sortedLessons), function(lesson) {
    return _c('li', {
      key: lesson.id
    }, [_c('span', {
      staticClass: "lesson-day"
    }, [_vm._v(_vm._s(lesson.name))]), _vm._v(" "), _c('span', {
      staticClass: "lesson-name"
    }, [_vm._v(_vm._s(lesson.title))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          _vm.openLesson(lesson)
        }
      }
    }, [_vm._v("Open")])])
  })), _vm._v(" "), (_vm.selectedCourse.instances && _vm.selectedCourse.instances.length) ? _c('div', {
    staticClass: "instances"
  }, [_c('h5', {
    staticClass: "bold"
  }, [_vm._v("Scheduled Runs")]), _vm._v(" "), _vm._l((_vm.selectedCourse.instances), function(instance) {
    return _c('div', {
      key: instance.id,
      staticClass: "instance well"
    }, [_c('div', {
      staticClass: "instance-header"
    }, [_c('div', {
      staticClass: "instance-details bold"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDate")(instance.startDate)) + " – " + _vm._s(_vm._f("formatDate")(instance.endDate)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(instance.slotsFilled) + "/" + _vm._s(instance.slots) + " slots filled")])]), _vm._v(" "), _c('div', {
      staticClass: "instance-actions"
    }, [_c('button', {
      staticClass: "btn btn-success btn-sm",
      on: {
        "click": function($event) {
          _vm.addMeeting(instance)
        }
      }
    }, [_vm._v("Add Live Session")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-sm",
      on: {
        "click": function($event) {
          _vm.openSubmissions(instance)
        }
      }
    }, [_vm._v(_vm._s(_vm.submissionsInstanceId === instance.id ? 'Hide Submissions' : 'Submissions'))]), _vm._v(" "), (new Date(instance.startDate) > new Date()) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          _vm.editInstance(instance)
        }
      }
    }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (new Date(instance.startDate) > new Date()) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.deleteInstance(instance)
        }
      }
    }, [_vm._v("Delete")]) : _vm._e()])]), _vm._v(" "), (instance.meetings && instance.meetings.length) ? _c('ul', {
      staticClass: "meeting-list"
    }, _vm._l((instance.meetings), function(meeting) {
      return _c('li', {
        key: meeting.id
      }, [_c('div', {
        staticClass: "meeting-info"
      }, [_c('span', {
        staticClass: "bold"
      }, [_vm._v("Day " + _vm._s(meeting.day))]), _vm._v(" "), _c('span', {
        staticClass: "meeting-title"
      }, [_vm._v(_vm._s(meeting.title))]), _vm._v(" "), _c('span', {
        staticClass: "meeting-time"
      }, [_vm._v(_vm._s(_vm.formatMeetingRange(meeting)))])]), _vm._v(" "), (new Date(meeting.startTime) > new Date()) ? _c('div', {
        staticClass: "meeting-actions"
      }, [_c('button', {
        staticClass: "btn btn-primary btn-sm",
        on: {
          "click": function($event) {
            _vm.editMeeting(meeting, instance)
          }
        }
      }, [_vm._v("Edit")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-danger btn-sm",
        on: {
          "click": function($event) {
            _vm.deleteMeeting(meeting, instance)
          }
        }
      }, [_vm._v("Delete")])]) : _vm._e()])
    })) : _vm._e(), _vm._v(" "), (_vm.submissionsInstanceId === instance.id) ? _c('div', {
      staticClass: "submissions"
    }, [(!_vm.submissions) ? _c('p', {
      staticClass: "text-muted"
    }, [_vm._v("Loading...")]) : (!_vm.submissions.length) ? _c('p', {
      staticClass: "text-muted"
    }, [_vm._v("No submissions yet")]) : _vm._l((_vm.groupedSubmissions), function(group) {
      return _c('div', {
        key: group.name,
        staticClass: "submission-group"
      }, [_c('div', {
        staticClass: "submission-group-header"
      }, [_c('h6', {
        staticClass: "submission-group-name"
      }, [_vm._v(_vm._s(group.name))]), _vm._v(" "), _c('a', {
        staticClass: "btn btn-default btn-sm",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.downloadAllSubmissions(group)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-download"
      }), _vm._v(" Download all")]), _vm._v(" "), _c('a', {
        staticClass: "btn btn-default btn-sm",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.downloadSubmissionsSheet(group)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-file-excel-o"
      }), _vm._v(" Download sheet")])]), _vm._v(" "), _c('ul', {
        staticClass: "submission-list"
      }, _vm._l((group.items), function(submission) {
        return _c('li', {
          key: submission.id,
          staticClass: "submission"
        }, [_c('div', {
          staticClass: "meta"
        }, [_c('span', {
          staticClass: "submission-info text-muted"
        }, [_vm._v(_vm._s(submission.user.firstName) + " " + _vm._s(submission.user.lastName))]), _vm._v(" "), _c('span', {
          staticClass: "submission-info text-muted"
        }, [_vm._v(_vm._s(_vm._f("shortDate")(submission.createdAt)))])]), _vm._v(" "), _c('div', {
          staticClass: "icons"
        }, [(submission.notes) ? _c('a', {
          staticClass: "btn btn-default btn-sm",
          attrs: {
            "href": "#",
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.openNotes(submission.notes)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-sticky-note-o"
        })]) : _vm._e(), _vm._v(" "), _c('a', {
          staticClass: "btn btn-default btn-sm",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.downloadSubmission(submission)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download"
        })])])])
      }))])
    })], 2) : _vm._e()])
  })], 2) : _vm._e()]) : _c('div', {
    staticClass: "panel-body"
  }, [_c('button', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": function($event) {
        _vm.selectedLesson = null
      }
    }
  }, [_vm._v("← Back")]), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [(_vm.selectedLesson.day > 0) ? _c('h4', [_vm._v("Day " + _vm._s(_vm.selectedLesson.day))]) : _c('h4', [_vm._v("Pre-Course")]), _vm._v(" "), _c('div', {
    staticClass: "lesson-actions"
  }, [(!_vm.selectedLesson.deliverable) ? _c('button', {
    staticClass: "btn btn-success btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addDeliverable($event)
      }
    }
  }, [_vm._v("Add Deliverable")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addDownload($event)
      }
    }
  }, [_vm._v("Add Download")])])]), _vm._v(" "), _c('ul', {
    staticClass: "lesson-tabs"
  }, [_c('li', {
    class: {
      active: _vm.lessonTab === 'information'
    },
    on: {
      "click": function($event) {
        _vm.lessonTab = 'information'
      }
    }
  }, [_vm._v("Information")]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.lessonTab === 'videos'
    },
    on: {
      "click": function($event) {
        _vm.lessonTab = 'videos'
      }
    }
  }, [_vm._v("Videos")]), _vm._v(" "), (_vm.selectedLesson.deliverable) ? _c('li', {
    class: {
      active: _vm.lessonTab === 'deliverable'
    },
    on: {
      "click": function($event) {
        _vm.lessonTab = 'deliverable'
      }
    }
  }, [_vm._v("Deliverable")]) : _vm._e(), _vm._v(" "), (_vm.selectedLesson.downloads && _vm.selectedLesson.downloads.length) ? _c('li', {
    class: {
      active: _vm.lessonTab === 'downloads'
    },
    on: {
      "click": function($event) {
        _vm.lessonTab = 'downloads'
      }
    }
  }, [_vm._v("Downloads")]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      active: _vm.lessonTab === 'notifications'
    },
    on: {
      "click": function($event) {
        _vm.lessonTab = 'notifications'
      }
    }
  }, [_vm._v("Notifications")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lessonTab === 'information'),
      expression: "lessonTab === 'information'"
    }],
    staticClass: "lesson-information well"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveLesson($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lessonForm.name),
      expression: "lessonForm.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lessonForm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lessonForm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lessonForm.title),
      expression: "lessonForm.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lessonForm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lessonForm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('html-editor', {
    ref: "lessonEditor",
    attrs: {
      "stickyToolbar": true,
      "tagMap": {
        h1: 'h3',
        h2: 'h4'
      }
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lessonTab === 'videos'),
      expression: "lessonTab === 'videos'"
    }],
    staticClass: "lesson-videos well"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm delete",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAddVideoModal = true
      }
    }
  }, [_vm._v("Add Video")]), _vm._v(" "), (_vm.selectedLesson.videos && _vm.selectedLesson.videos.length) ? _c('draggable', {
    staticClass: "videos",
    attrs: {
      "tag": "ul",
      "handle": ".drag-handle"
    },
    on: {
      "end": _vm.reorderVideos
    },
    model: {
      value: (_vm.selectedLesson.videos),
      callback: function($$v) {
        _vm.selectedLesson.videos = $$v
      },
      expression: "selectedLesson.videos"
    }
  }, _vm._l((_vm.selectedLesson.videos), function(video) {
    return _c('li', {
      key: video.id
    }, [_c('div', {
      staticClass: "video-title"
    }, [_c('i', {
      staticClass: "fa fa-bars drag-handle"
    }), _vm._v("\n                            " + _vm._s(video.title || '(Untitled video)') + "                                \n                            "), _c('span', {
      staticClass: "cursor-pointer",
      on: {
        "click": function($event) {
          _vm.openVideo(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit edit-icon"
    })]), _vm._v(" "), _c('span', {
      staticClass: "cursor-pointer delete-video",
      on: {
        "click": function($event) {
          _vm.deleteVideo(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]), _vm._v(" "), (!video.url) ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('No video file uploaded'),
        expression: "'No video file uploaded'"
      }]
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    })]) : _vm._e()])])
  })) : _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("No videos yet")])], 1), _vm._v(" "), (_vm.selectedLesson.deliverable) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lessonTab === 'deliverable'),
      expression: "lessonTab === 'deliverable'"
    }],
    staticClass: "deliverable well"
  }, [_c('button', {
    staticClass: "btn btn-danger delete btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteDeliverable($event)
      }
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveDeliverable($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliverableForm.name),
      expression: "deliverableForm.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.deliverableForm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deliverableForm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('html-editor', {
    ref: "deliverableEditor",
    attrs: {
      "stickyToolbar": true,
      "tagMap": {
        h1: 'h3',
        h2: 'h4'
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliverableForm.isFinal),
      expression: "deliverableForm.isFinal"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.deliverableForm.isFinal) ? _vm._i(_vm.deliverableForm.isFinal, null) > -1 : (_vm.deliverableForm.isFinal)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.deliverableForm.isFinal,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.deliverableForm.isFinal = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.deliverableForm.isFinal = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.deliverableForm.isFinal = $$c
        }
      }
    }
  }), _vm._v("\n                            Final deliverable\n                        ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save Deliverable")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedLesson.downloads && _vm.selectedLesson.downloads.length) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lessonTab === 'downloads'),
      expression: "lessonTab === 'downloads'"
    }],
    staticClass: "downloads well"
  }, [_c('ul', {
    staticClass: "download-list"
  }, _vm._l((_vm.selectedLesson.downloads), function(download) {
    return _c('li', {
      key: download.id
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (download.name),
        expression: "download.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (download.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          download.name = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "download-actions"
    }, [_c('button', {
      staticClass: "btn btn-success btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.saveDownload(download)
        }
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadFile(download.url)
        }
      }
    }, [_vm._v("Download")]), _vm._v(" "), _c('label', {
      staticClass: "btn btn-default btn-sm"
    }, [_vm._v("\n                                " + _vm._s(download.thumbnail ? 'Change Thumbnail' : 'Add Thumbnail') + "\n                                "), _c('input', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.setDownloadThumbnail(download, $event)
        }
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteDownload(download)
        }
      }
    }, [_vm._v("Delete")])])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lessonTab === 'notifications'),
      expression: "lessonTab === 'notifications'"
    }],
    staticClass: "notifications well"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openAddNotificationModal($event)
      }
    }
  }, [_vm._v("Add Notification")]), _vm._v(" "), (_vm.selectedLesson.notifications && _vm.selectedLesson.notifications.length) ? _c('ul', {
    staticClass: "notification-list"
  }, _vm._l((_vm.selectedLesson.notifications), function(notification) {
    return _c('li', {
      key: notification.id
    }, [(notification.color) ? _c('div', {
      staticClass: "notification-color-swatch",
      style: ({
        background: notification.color
      })
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "notification-header"
    }, [_vm._v(_vm._s(notification.header))]), _vm._v(" "), _c('div', {
      staticClass: "notification-actions"
    }, [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openEditNotificationModal(notification)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteNotification(notification)
        }
      }
    }, [_vm._v("Delete")])])])
  })) : _c('p', {
    staticClass: "text-muted",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_vm._v("No notifications yet")])])])]), _vm._v(" "), (_vm.showCreateModal) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCreateModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-box nice-scrollbar modal-box-lg",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h4', [_vm._v("Create Trial Course")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createCourse($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Duration (days)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.duration),
      expression: "form.duration",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.duration = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('html-editor', {
    ref: "createCourseEditor",
    attrs: {
      "stickyToolbar": true,
      "tagMap": {
        h1: 'h3',
        h2: 'h4'
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "video-upload"
  }, [_vm._v("\n                        " + _vm._s(_vm.form.introVideoFileName || 'Upload intro video') + "\n                        "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "video/mp4"
    },
    on: {
      "change": _vm.setCreateCourseIntroVideo
    }
  })]), _vm._v(" "), (_vm.form.introVideoFileName) ? _c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "filename"
  }, [_vm._v(_vm._s(_vm.form.introVideoFileName)), _c('i', {
    staticClass: "fa fa-remove",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearCreateCourseIntroVideo($event)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showCreateModal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showEditCourseModal) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showEditCourseModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-box nice-scrollbar modal-box-lg",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h4', [_vm._v("Edit Course")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitEditCourse($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('html-editor', {
    ref: "editCourseEditor",
    attrs: {
      "stickyToolbar": true,
      "tagMap": {
        h1: 'h3',
        h2: 'h4'
      }
    }
  })], 1), _vm._v(" "), (_vm.editCourseForm.existingIntroVideoUrl) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Current Intro Video")]), _vm._v(" "), _c('div', {
    staticClass: "video-wrapper"
  }, [_c('div', {
    staticClass: "video"
  }, [(_vm.editCourseForm.introVideoPreviewUrl) ? _c('poly-video', {
    attrs: {
      "sources": [_vm.editCourseForm.introVideoPreviewUrl],
      "vjsOptions": _vm.videoPlayerVjsOptions
    }
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "video-upload"
  }, [_vm._v("\n                        " + _vm._s(_vm.editCourseForm.introVideoFileName || 'Upload intro video') + "\n                        "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "video/mp4"
    },
    on: {
      "change": _vm.setEditCourseIntroVideo
    }
  })]), _vm._v(" "), (_vm.editCourseForm.introVideoFileName) ? _c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "filename"
  }, [_vm._v(_vm._s(_vm.editCourseForm.introVideoFileName)), _c('i', {
    staticClass: "fa fa-remove",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearEditCourseIntroVideo($event)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showEditCourseModal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showAddVideoModal) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAddVideoModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-box nice-scrollbar",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h4', [_vm._v("Add Video")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitAddVideo($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addVideoForm.title),
      expression: "addVideoForm.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.addVideoForm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addVideoForm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "video-upload"
  }, [_vm._v("\n                        " + _vm._s(_vm.addVideoForm.fileName || 'Upload video') + "\n                        "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "video/mp4"
    },
    on: {
      "change": _vm.setAddVideoFile
    }
  })]), _vm._v(" "), (_vm.addVideoForm.fileName) ? _c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "filename"
  }, [_vm._v(_vm._s(_vm.addVideoForm.fileName)), _c('i', {
    staticClass: "fa fa-remove",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearAddVideoFile($event)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showAddVideoModal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Add")])])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedVideo) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectedVideo = null
      }
    }
  }, [_c('div', {
    staticClass: "modal-box nice-scrollbar modal-box-lg",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "video-header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.selectedVideo.title || '(Untitled video)'))]), _vm._v(" "), (_vm.selectedVideo.transcript) ? _c('i', {
    staticClass: "fa fa-file-text-o toggle-transcript",
    attrs: {
      "title": "Show/hide Transcript"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showTranscript = !_vm.showTranscript
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.selectedVideo.transcript && _vm.showTranscript) ? _c('div', {
    staticClass: "transcript"
  }, _vm._l((_vm.selectedVideo.transcript.text), function(line) {
    return _c('span', [_vm._v(_vm._s(line.text) + " ")])
  })) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveVideo($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.videoForm.title),
      expression: "videoForm.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.videoForm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.videoForm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.selectedVideo.url) ? _c('div', {
    staticClass: "video-wrapper"
  }, [_c('div', {
    staticClass: "video"
  }, [(_vm.videoUrl) ? _c('poly-video', {
    ref: "videoPlayer",
    attrs: {
      "sources": [_vm.videoUrl],
      "vjsOptions": _vm.videoPlayerVjsOptions
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "video-upload"
  }, [_vm._v("\n                        Upload video\n                        "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "video/mp4"
    },
    on: {
      "change": _vm.setFile
    }
  })]), _vm._v(" "), (_vm.videoForm.fileName) ? _c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "filename"
  }, [_vm._v(_vm._s(_vm.videoForm.fileName)), _c('i', {
    staticClass: "fa fa-remove",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearFile()
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectedVideo = null
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showScheduleModal) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showScheduleModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-box nice-scrollbar",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h4', [_vm._v("Schedule Course Run")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitSchedule($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduleForm.startDate),
      expression: "scheduleForm.startDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.scheduleForm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scheduleForm.startDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Slots")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.scheduleForm.slots),
      expression: "scheduleForm.slots",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "required": ""
    },
    domProps: {
      "value": (_vm.scheduleForm.slots)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scheduleForm.slots = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Time")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduleForm.startTime),
      expression: "scheduleForm.startTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time",
      "required": ""
    },
    domProps: {
      "value": (_vm.scheduleForm.startTime)
    },
    on: {
      "change": _vm.autoSetEndTime,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scheduleForm.startTime = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Timezone")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduleForm.timezone),
      expression: "scheduleForm.timezone"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.scheduleForm.timezone = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.timeZones), function(tz) {
    return _c('option', {
      key: tz.value,
      domProps: {
        "value": tz.value
      }
    }, [_vm._v(_vm._s(tz.label))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showScheduleModal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Schedule")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showEditInstanceModal) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showEditInstanceModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-box nice-scrollbar",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h4', [_vm._v("Edit Course Run")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitEditInstance($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editInstanceForm.startDate),
      expression: "editInstanceForm.startDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.editInstanceForm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editInstanceForm.startDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Slots")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.editInstanceForm.slots),
      expression: "editInstanceForm.slots",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "required": ""
    },
    domProps: {
      "value": (_vm.editInstanceForm.slots)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editInstanceForm.slots = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showEditInstanceModal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showAddDownloadModal) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAddDownloadModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-box nice-scrollbar",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h4', [_vm._v("Add Download")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitAddDownload($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.downloadForm.name),
      expression: "downloadForm.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.downloadForm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.downloadForm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Source")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.downloadForm.useUrl),
      expression: "downloadForm.useUrl"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.downloadForm.useUrl, false)
    },
    on: {
      "__c": function($event) {
        _vm.downloadForm.useUrl = false
      }
    }
  }), _vm._v(" Upload file")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline",
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.downloadForm.useUrl),
      expression: "downloadForm.useUrl"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.downloadForm.useUrl, true)
    },
    on: {
      "__c": function($event) {
        _vm.downloadForm.useUrl = true
      }
    }
  }), _vm._v(" URL")])])]), _vm._v(" "), (!_vm.downloadForm.useUrl) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "video-upload"
  }, [_vm._v("\n                        " + _vm._s(_vm.downloadForm.fileName || 'Choose file') + "\n                        "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.setDownloadFile
    }
  })]), _vm._v(" "), (_vm.downloadForm.fileName) ? _c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "filename"
  }, [_vm._v(_vm._s(_vm.downloadForm.fileName)), _c('i', {
    staticClass: "fa fa-remove",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearDownloadFile($event)
      }
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.downloadForm.useUrl) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.downloadForm.url),
      expression: "downloadForm.url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "url",
      "placeholder": "https://...",
      "required": ""
    },
    domProps: {
      "value": (_vm.downloadForm.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.downloadForm.url = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('label', {
    staticClass: "video-upload"
  }, [_vm._v("\n                        " + _vm._s(_vm.downloadForm.thumbnailName || 'Choose image') + "\n                        "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.setThumbnailFile
    }
  })]), _vm._v(" "), (_vm.downloadForm.thumbnailName) ? _c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "filename"
  }, [_vm._v(_vm._s(_vm.downloadForm.thumbnailName)), _c('i', {
    staticClass: "fa fa-remove",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearThumbnailFile($event)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showAddDownloadModal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Add")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showAddMeetingModal) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAddMeetingModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-box nice-scrollbar",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h4', [_vm._v("Add Live Session")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitAddMeeting($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Day")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.meetingForm.day),
      expression: "meetingForm.day",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.meetingForm.day = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onMeetingDayChange]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select a day")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Pre-course")]), _vm._v(" "), _vm._l((_vm.sortedLessons.length), function(i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                            " + _vm._s('Day ' + i) + "\n                        ")])
  })], 2)]), _vm._v(" "), (_vm.meetingForm.day === 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.meetingForm.date),
      expression: "meetingForm.date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.meetingForm.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.meetingForm.date = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.meetingForm.title),
      expression: "meetingForm.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.meetingForm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.meetingForm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Time")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.meetingForm.startTime),
      expression: "meetingForm.startTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time",
      "required": ""
    },
    domProps: {
      "value": (_vm.meetingForm.startTime)
    },
    on: {
      "change": _vm.autoSetEndTime,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.meetingForm.startTime = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Time")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.meetingForm.endTime),
      expression: "meetingForm.endTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time",
      "required": ""
    },
    domProps: {
      "value": (_vm.meetingForm.endTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.meetingForm.endTime = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Host")]), _vm._v(" "), (_vm.staffMembers) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.meetingForm.hostId),
      expression: "meetingForm.hostId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.meetingForm.hostId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select a host")]), _vm._v(" "), _vm._l((_vm.staffMembers), function(member) {
    return _c('option', {
      domProps: {
        "value": member.username
      }
    }, [_vm._v("\n                            " + _vm._s(member.firstName) + " " + _vm._s(member.lastName) + "\n                        ")])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Timezone")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.meetingForm.timezone),
      expression: "meetingForm.timezone"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.meetingForm.timezone = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.timeZones), function(tz) {
    return _c('option', {
      key: tz.value,
      domProps: {
        "value": tz.value
      }
    }, [_vm._v(_vm._s(tz.label))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showAddMeetingModal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Add")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showAddNotificationModal) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAddNotificationModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-box nice-scrollbar modal-box-lg",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h4', [_vm._v("Add Notification")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitAddNotification($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Header")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notificationForm.header),
      expression: "notificationForm.header"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.notificationForm.header)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notificationForm.header = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Text")]), _vm._v(" "), _c('html-editor', {
    ref: "notificationEditor",
    attrs: {
      "stickyToolbar": true,
      "tagMap": {
        h1: 'h3',
        h2: 'h4'
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "color-picker"
  }, [_c('div', {
    staticClass: "color-swatch no-color",
    class: {
      selected: !_vm.notificationForm.color
    },
    on: {
      "click": function($event) {
        _vm.notificationForm.color = null
      }
    }
  }, [_vm._v("None")]), _vm._v(" "), _vm._l((_vm.colors), function(hex, name) {
    return _c('div', {
      key: name,
      staticClass: "color-swatch",
      class: {
        selected: _vm.notificationForm.color === hex
      },
      style: ({
        background: hex
      }),
      attrs: {
        "title": name
      },
      on: {
        "click": function($event) {
          _vm.notificationForm.color = hex
        }
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showAddNotificationModal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Add")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showEditNotificationModal) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showEditNotificationModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-box nice-scrollbar modal-box-lg",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h4', [_vm._v("Edit Notification")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitEditNotification($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Header")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editNotificationForm.header),
      expression: "editNotificationForm.header"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.editNotificationForm.header)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editNotificationForm.header = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Text")]), _vm._v(" "), _c('html-editor', {
    ref: "editNotificationEditor",
    attrs: {
      "stickyToolbar": true,
      "tagMap": {
        h1: 'h3',
        h2: 'h4'
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "color-picker"
  }, [_c('div', {
    staticClass: "color-swatch no-color",
    class: {
      selected: !_vm.editNotificationForm.color
    },
    on: {
      "click": function($event) {
        _vm.editNotificationForm.color = null
      }
    }
  }, [_vm._v("None")]), _vm._v(" "), _vm._l((_vm.colors), function(hex, name) {
    return _c('div', {
      key: name,
      staticClass: "color-swatch",
      class: {
        selected: _vm.editNotificationForm.color === hex
      },
      style: ({
        background: hex
      }),
      attrs: {
        "title": name
      },
      on: {
        "click": function($event) {
          _vm.editNotificationForm.color = hex
        }
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showEditNotificationModal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showNotesModal) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showNotesModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-box nice-scrollbar modal-box-lg",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h4', [_vm._v("Submission Notes")]), _vm._v(" "), _c('p', {
    staticClass: "notes-text"
  }, [_vm._v(_vm._s(_vm.notesModalText))]), _vm._v(" "), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showNotesModal = false
      }
    }
  }, [_vm._v("Close")])])])]) : _vm._e(), _vm._v(" "), (_vm.showEditMeetingModal) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showEditMeetingModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-box nice-scrollbar",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h4', [_vm._v("Edit Live Session")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitEditMeeting($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editMeetingForm.title),
      expression: "editMeetingForm.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.editMeetingForm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editMeetingForm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.editMeetingForm.day === 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editMeetingForm.date),
      expression: "editMeetingForm.date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.editMeetingForm.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editMeetingForm.date = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Time")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editMeetingForm.startTime),
      expression: "editMeetingForm.startTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time",
      "required": ""
    },
    domProps: {
      "value": (_vm.editMeetingForm.startTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editMeetingForm.startTime = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Time")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editMeetingForm.endTime),
      expression: "editMeetingForm.endTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time",
      "required": ""
    },
    domProps: {
      "value": (_vm.editMeetingForm.endTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editMeetingForm.endTime = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Host")]), _vm._v(" "), (_vm.staffMembers) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editMeetingForm.hostId),
      expression: "editMeetingForm.hostId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editMeetingForm.hostId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select a host")]), _vm._v(" "), _vm._l((_vm.staffMembers), function(member) {
    return _c('option', {
      domProps: {
        "value": member.username
      }
    }, [_vm._v("\n                            " + _vm._s(member.firstName) + " " + _vm._s(member.lastName) + "\n                        ")])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showEditMeetingModal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Thumbnail "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(optional)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Color "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(optional)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Color "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(optional)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d2a06ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TrialCourses.vue
// module id = 2006
// module chunks = 2